import { Vertragsoptionen } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';

export const selectVertragsoptionen = (state: IAppState): Vertragsoptionen =>
  state.vertragsoptionen;

export const selectIsNeugeschaeft = (state: IAppState): boolean =>
  !state.vertragsoptionen.vorvertragsNummern ||
  state.vertragsoptionen.vorvertragsNummern.length === 0;

export const selectZahlweise = (state: IAppState): string =>
  state.vertragsoptionen.zahlungsweise.toLowerCase();

export const selectIsErsatzgeschaeft = (state: IAppState): boolean =>
  state.vertragsoptionen.vorvertragsNummern?.length > 0 && !state.vertragsoptionen.beibehalten;

export const selectVorschaedenVisibleInErsatzgeschaeft = (state: IAppState): boolean =>
  selectIsErsatzgeschaeft(state) &&
  (state.vorschaeden.elementarVorschaden?.visibleInErsatzgeschaeft === true ||
    state.vorschaeden.feuerVorschaden?.visibleInErsatzgeschaeft === true ||
    state.vorschaeden.sturmhagelVorschaden?.visibleInErsatzgeschaeft === true ||
    state.vorschaeden.leitungswasserVorschaden?.visibleInErsatzgeschaeft === true);
